import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import AccountSearchForm from './search-form.js'

const AccountSearchModel = {
  nome: null
}

export default {
  mixins: [ActionsForm],
  name: 'AccountSearch',
  data () {
    return {
      data: AccountSearchModel,
      form: AccountSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/account/components/search/search.js